import React from "react";
import styled, { css } from "styled-components";
import { useModalContext } from "common/contexts";
import { Button } from "components/bootstrap";
const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.xs};
    flex-direction: column;
  `
);
const ButtonBox = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.xs};
    & > * {
      flex: 1;
    }
  `
);
const EventActions = ({ securityEvent }) => {
  const { setModal, setEntity } = useModalContext();
  const openEvidenceModal = () => {
    const { event } = securityEvent;
    setEntity([event.id]);
    setModal("ADD-EVIDENCE");
  };
  const sendNotification = () => {
    setEntity(securityEvent);
    setModal("SEND-NOTIFICATION");
  };
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(ButtonBox, null, /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", onClick: openEvidenceModal }, "Add to an Investigation"), /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", onClick: sendNotification }, "Send Notification")));
};
export default EventActions;
